enum DataState {
    Initial,
    Loading,
    Loaded,
    Error,
}

export {DataState};